export default {
  "welcome": {
    "welcome-to": "Chào mừng đến",
    "one-philly": "Một Philly,",
    "united-city": "Một thành phố thống nhất!",
  },
  "city-offices": {
    "city-offices-title": "Văn phòng thành phố",
    "city-offices-text-1": "Văn phòng thành phố mở cửa trong giờ làm việc thông thường. Một số dịch vụ đang được cung cấp trực tuyến hoặc theo lịch hẹn. Để tìm hiểu thêm, ",
    "city-offices-text-2": "kiểm tra với bộ phận quan tâm của bạn.",
    "city-offices-closure-text": "",
    "trash-title": "Thùng rác & tái chế",
    "trash-text-1": "Các bộ sưu tập rác và tái chế đều nằm trong lịch trình nghỉ lễ. Đặt tài liệu ra sau ngày bình thường của bạn một ngày.",
    "trash-text-2": "Để tìm hiểu thêm, ",
    "trash-text-3": "kiểm tra lịch trình kỳ nghỉ.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "Tìm ngày rác của bạn",
    "bill": "Thanh toán hóa đơn",
    "jobs": "Khám phá việc làm thành phố",
    "property": "Tìm kiếm tài sản",
    "taxes": "Nộp và nộp thuế thành phố",
    "recycle": "Tái chế lá mùa thu",
    "visit": "Thăm một người bị giam",
    "license": "Nhận giấy phép",
    "popular-services": "Dịch vụ phổ biến",
    "jump-to-all-services": "Chuyển đến tất cả các dịch vụ",
    "services-by-topic": "Dịch vụ theo chủ đề",
    "see-all-services": "Xem tất cả các dịch vụ",
  },
  "tools": {
    "parks-finder": "công viên và công cụ tìm giải trí",
    "contracts": "trung tâm hợp đồng",
    "school-time-activity": "công cụ tìm hoạt động ngoài giờ học",
    "food-meal": "công cụ tìm thức ăn và bữa ăn miễn phí",
    "atlas": "tập bản đồ",
    "primary": "công cụ tìm kiếm chăm sóc ban đầu",
    "eclipse": "nhật thực",
    "mail-vote-remind": "gửi thư trong lời nhắc bỏ phiếu",
    "street-smart": "StreetSmartPHL",
    "commonly-used-tools": "Các công cụ thường được sử dụng",
    "see-all-tools": "Xem tất cả các công cụ",
  },
  "news": {
    "featured-news": "Tin tức nổi bật",
    "see-all-news": "Xem tất cả tin tức",
  },
  "311": {
    "report-311": "Giúp Philadelphia trở thành thành phố lớn an toàn nhất, sạch nhất, xanh nhất trên toàn quốc. Báo cáo các lô đất trống, graffiti, ô tô bị bỏ hoang và hơn thế nữa cho Philly311.",
    "report-problem": "BÁO CÁO MỘT VẤN ĐỀ",
    "track-request": "THEO DÕI YÊU CẦU",
    "ask-question": "ĐẶT CÂU HỎI",
  },
  "stay-connected": {
    "stay-connected": "Luôn kết nối",
    "sign-up-email": "Đăng ký nhận thông tin cập nhật qua email từ Thành phố Philadelphia",
    "sign-up": "Đăng ký",
  },
  "footer": {
    "elected-officials": "Các quan chức được bầu",
    "mayor": "Thị trưởng",
    "city-council": "Hội đồng thành phố",
    "courts": "Tòa án",
    "district-attorney": "Luật sư quận",
    "city-controller": "Kiểm soát viên thành phố",
    "sheriff": "Cảnh sát trưởng",
    "city-commissioners": "Ủy viên thành phố",
    "register-wills": "Sổ đăng ký di chúc",
    "open-govt": "Chính phủ mở",
    "code-charter": "Quy tắc & Điều lệ Philadelphia",
    "city-records": "Hồ sơ thành phố",
    "city-agency-regs": "Quy định cơ quan thành phố",
    "executive-orders": "Lệnh điều hành",
    "honesty-govt": "Trung thực trong chính phủ",
    "voting-elections": "Bỏ phiếu & bầu cử",
    "open-data": "Dữ liệu mở",
    "org-chart": "Sơ đồ tổ chức thành phố",
    "explore-phila": "Khám phá Philadelphia",
    "visit-phila": "Ghé thăm Philadelphia",
  },
  "clean-green": {
    "clean-green": "Sạch và xanh ",
    "clean-green-statement": "Thành phố của chúng tôi đang tập hợp lại với nhau để biến Philly trở thành thành phố lớn an toàn nhất, sạch nhất và xanh nhất trên toàn quốc, với cơ hội kinh tế cho tất cả mọi người. Thực hiện theo chiến lược toàn thành phố nhằm giải quyết các vấn đề chất lượng cuộc sống ở mọi khu phố.",
    "blocks-swept": "Các khối bị quét",
    "abandoned-autos": "Những chiếc ô tô bị bỏ rơi đã bị xóa",
    "properties-cleaned": "Thuộc tính được làm sạch và niêm phong",
    "graffiti-removed": "Graffiti bị xóa",
    "see-all-clean-green": "XEM TẤT CẢ SẠCH & XANH",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker là thị trưởng thứ 100 của Philadelphia và là người phụ nữ đầu tiên giữ chức vụ này trong 341 năm. Là một cư dân suốt đời của thành phố, cô cam kết chiến đấu mỗi ngày cho người Philadelphia.",
    "learn-more": "Tìm hiểu thêm",
  },
  "city-council": {
    "city-council": "Hội đồng thành phố",
    "district-council-member": "District Council Member",
    "council-member-al":  "Thành viên Hội đồng Quận",
    "council-president": "Chủ tịch Hội đồng",
    "dep-majority-whip": "Phó đa số Whip",
    "majority-whip": "Đa số roi",
    "minority-leader": "Lãnh đạo thiểu số",
    "minority-whip": "Roi thiểu số",
    "majority-leader": "Lãnh đạo đa số",
  }, 
  "philly-stat-360": {
    "ps360": "Thống kê Philly 360",
    "data-subheader": "Biến dữ liệu thành hành động cho cộng đồng của chúng ta.",
  },
};